import type { useHistory } from 'react-router-dom';
import type { GenericResponse, ResponseData } from 'api/http_requests';
import { makeAuthenticatedRequest, postData } from 'api/http_requests';

export async function requestOfferLetter(
  history: ReturnType<typeof useHistory>,
): Promise<ResponseData<GenericResponse> | null> {
  const response = await makeAuthenticatedRequest(
    () => postData('/api/web_offer/request_offer_letter', {}),
    history,
  );
  return response;
}
